const MenuTop = () => {
  return (
    <div class="menu_top">
      <ul>
        <li>
          <a href="/trang1">Trang 1</a>
        </li>
        <li>
          <a href="/trang2">Trang 2</a>
        </li>
      
      </ul>
    </div>
  );
};
export default MenuTop;
